import * as service from './service'
export default {
  namespace: 'insuranceBuyRecord',
  state: {
    recordList: {}
  },
  effects: {
    * pagingInsureRecords ({ payload }, { call, put }) {
      try {
        const res = yield call(service.pagingInsureRecords, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },
    // 购买
    * buyInsurance ({ payload }, { call, put }) {
      try {
        const res = yield call(service.buyInsurance, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
